import { graphql } from '@api/generated';

export const getAllCallContinuitySettings = graphql(`
  query getAllCallContinuitySettings {
    callContinuitySettingsForAllTenants {
      tenantId
      tenant {
        id
        name
      }
      isEnabled
      defaultForwardingNumber
      isVoiceAgent
      numActivePhoneLines
      numActivePhoneLinesWithoutDefaultForwarding
    }
  }
`);
